// import { firebase, googleAuthProvider } from '../firebase/firebase';
import axios from 'axios';
import isEmpty  from 'lodash/isEmpty';
import { history }  from '../routers/AppRouter'
import { picAppError, clearPicAppError }  from './picapp';
import getAppConfigParm  from '../config/AppConfig';
import dpbutils from '../utils/dpbutils';
// import { dispatch } from 'react-redux';

let filename = 'todos.js'

export const updateTodosList = (list) => {
    let todosCopy = copyListAndRemoveJsx(list);
    return {
        type: 'UPDATE_TODOS_LIST',
        list: todosCopy
    }   
};

export const startUpdateTodosList = (list, saveAndNext) => {
    return (dispatch, getState ) => {

        /* obtain current event_id */
        let event_id = getState().event.active._id;
  
        // initialize pertinent error message related information
        let errmsg = '';
        let functionName = 'startUpdateTodosList';
        let uri = 'PUT /event/todos';
        let userEmail = getState().auth.user.email;

        /* Obtain user token */
        let token = getState().auth.token;
        // Construct url and request header 
        let url         = getAppConfigParm("picUrl") + `/event/todos`; 
        let header      = getAppConfigParm("axiosConfig", token);
        let reqBody     = {
            event_id,   
            todos: list
        }

        // Make api call to  update items list
        axios.put(url, reqBody, header)
         .then((response) => {

            /* update the store */
            dispatch(updateTodosList(list));
          
            if (getState().picapp.error) {
                dispatch(clearPicAppError());
            }
            if (saveAndNext) {
                history.push("/eventmanage/invites");
            }
        }).catch ((error) => {
            // Note: Although I was getting a response in then block and successfully saving the event info, 
            // I was getting a 204 http code along with an empty error object. Hence why the check below
            // If error object is empty, I do not dispatch an app error event. 
            if (!isEmpty(error)) {
                if (error.response) {   /* server responded with status code out of 2xx range(success) */
                    if (error.response.data.errmsg) {
                        errmsg = `UncaughtException ${error.response.status}: error encountered in ${functionName} for user ${userEmail}` +
                                           `${error.response.data.errmsg}`
                        dispatch(picAppError("Something wrong: May want to try logging out and logging in again"));
                    }
                } else if (error.request) { /* request made but no response received */
                    errmsg = `UncaughtException(1): no response from uri:${uri}' from function ${functionName} by user ${userEmail}`;
                    dispatch(picAppError("Server busy: please try again later"));
                } else { /* something happened setting up request that triggered error */
                    if (error.message.indexOf('Network Error') !== -1 ) {
                        errmsg =  `NetworkError: occurred making axios call uri:'${uri}' from function ${functionName} by email:'${userEmail}' ErrorMsg: ${error.message}`;
                        dispatch(picAppError("Server busy:  please try us again later"));
                    } else {
                        errmsg = `UncaughtException(2): calling uri:'${uri}' from function ${functionName} from ${userEmail}`
                        dispatch(picAppError("Server busy: please try us again later"));
                    }
                }
            } else {
                errmsg = `UncaughtException(3): occurred with axios call uri:'${uri}' from function:${functionName}. Email:'${userEmail}'. If error object  empty, this may be a coding error (not API) within axios then block`;
            } /* end of !isEmpty */
            errmsg && dpbutils.saveErrorRecord(appname, filename, functionName, userEmail, errmsg, error);
        });
    }
};


/* This function makes a deep copy of the array of objects, while also clearing out the 
   actionIconsJsx property, which causes issues if saved into redux. */
function copyListAndRemoveJsx (list) {
    let newList = [];
    list.forEach((item) => {
        newList.push({
            todo: item.todo,
            peopleNeeded: item.peopleNeeded,
            participants: item.participants,
            actionIconsJsx: ""
        });
    });
      /* return modified copy of list */
    return newList;
}



// WEBPACK FOOTER //
// ./src/actions/todos.js